const DEFAULT_PALETTE_CONFIG = {
  id: ``,
  name: ``,
  value: ``,
  h: 0,
  s: 0,
  lMin: 0,
  lMax: 100,
  useLightness: true,
};

module.exports = { DEFAULT_PALETTE_CONFIG };
